module.exports = __webpack_public_path__ + "public/Icons/loginArrowDark.svg?f63b5cc1";